import * as allActivityManage from '../services/index';
export default {
  namespace: 'allActivityManage',
  state: {
    getActivityManageList: {},
    comparisonList: [],
  },
  effects: {
    *getActivityManageList({ payload: { values } }, { call, put }) {
      const response = yield call(allActivityManage.getActivityManageList, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          getActivityManageList: response,
        },
      });
    },
    *queryComparison({ payload: { values }, callback }, { call, put }) {
      const response = yield call(allActivityManage.queryComparison, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          comparisonList: response.data,
        },
      });
      callback(response?.data);
    },
  },
  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
